import { ArrowLeftIcon, CalendarDaysIcon, MoreVerticalIcon, PenLineIcon, SquareUserRoundIcon, UsersIcon } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import EditGroup from '@/components/features/manage/manage-groups/EditGroup';
import EditGroupSchedule from '@/components/features/manage/manage-groups/EditGroupSchedule';
import EditGroupUsers from '@/components/features/manage/manage-groups/EditGroupUsers';
import GroupAvatarEditor from '@/components/features/manage/manage-groups/GroupAvatarEditor';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Skeleton } from '@/components/ui/skeleton';
import { useCredentials } from '@/store/auth-store';
import { getAvatar } from '@/utils/getAvatar';

interface GroupHeaderProps {
  groupName?: string;
  groupId?: number;
  groupAvatarURL?: string;
}

export default function GroupHeader(groupHeaderProps: GroupHeaderProps) {
  const { groupName, groupAvatarURL, groupId } = groupHeaderProps;
  const { lvl } = useCredentials();

  const navigate = useNavigate();
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [openEditSchedule, setOpenEditSchedule] = useState<boolean>(false);
  const [openEditAvatar, setOpenEditAvatar] = useState<boolean>(false);
  const [openEditUsers, setOpenEditUsers] = useState<boolean>(false);

  const handleNavigateBack = () => {
    navigate(-1);
  };

  return (
    <>
      {lvl > 0 && (
        <>
          <GroupAvatarEditor open={openEditAvatar} onOpenChange={setOpenEditAvatar} id={groupId} />
          <EditGroupUsers id={groupId} open={openEditUsers} onOpenChange={setOpenEditUsers} />
          <EditGroupSchedule id={groupId} open={openEditSchedule} onOpenChange={setOpenEditSchedule} />
          <EditGroup id={groupId} open={openEdit} onOpenChange={setOpenEdit} />
        </>
      )}

      <div className={'border-border-primary bg-surface-primary flex w-full flex-col gap-3 rounded-2xl border p-4'}>
        <div className={'flex items-center gap-2'}>
          <Button variant={'ghost'} size={'sm'} onClick={handleNavigateBack}>
            <ArrowLeftIcon />
          </Button>
          <Avatar size={'md'}>
            <AvatarImage src={getAvatar(groupAvatarURL)} alt={`group-${groupName}`} />
            <AvatarFallback>
              <UsersIcon />
            </AvatarFallback>
          </Avatar>
          {groupName ? <h2 className={'text-fg-primary self-center text-xl font-semibold'}>{groupName}</h2> : <Skeleton className={'h-5 w-full max-w-48 rounded-sm'} />}

          {lvl > 0 && (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant={'ghost'} size={'sm'} className="ms-auto">
                  <MoreVerticalIcon />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align={'end'} className="w-fit">
                <DropdownMenuGroup>
                  <DropdownMenuItem onClick={() => setOpenEditUsers(true)}>
                    <UsersIcon className="size-4" />
                    Edytuj użytkowników
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => setOpenEdit(true)}>
                    <PenLineIcon className="size-4" />
                    Edytuj grupę
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => setOpenEditSchedule(true)}>
                    <CalendarDaysIcon className="size-4" />
                    Edytuj harmonogram
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => setOpenEditAvatar(true)}>
                    <SquareUserRoundIcon className="size-4" />
                    Edytuj awatar
                  </DropdownMenuItem>
                </DropdownMenuGroup>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
        <div className={'gap- flex flex-wrap empty:hidden'}></div>
      </div>
    </>
  );
}
